module.exports = __webpack_public_path__ + "img/down_excel_btn.5cd1e38b.svg";